<template>

  <div>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="loading_page" v-if="loading">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>
      <div class="m-2">
        <landfill-plan-form
            :on-submit="onSubmit"
            :areas-items="form.areas"
            :landfills-items="form.landfills"
            :plan-data="form"
            :errors="errors">
        </landfill-plan-form>
      </div>
    </b-card>
  </div>
</template>

<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormInvalidFeedback,
  BBadge, BDropdown, BDropdownItem, BPagination, BForm,BFormGroup, BFormCheckboxGroup
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { onUnmounted,} from '@vue/composition-api'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import Ripple from "vue-ripple-directive"
import LandfillPlanForm from './share/LandfillPlanForm'
import PlanStore from '../functions/plansStore'
import useLandfill from './share/useLandfillPlan'

export default {
  components: {
    OrbitSpinner,flatPickr,BFormInvalidFeedback,
    BCard, BRow, BCol, BFormInput, BButton, BTable,BFormCheckboxGroup,
    BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,
    vSelect, BForm, BFormGroup,
    LandfillPlanForm
  },
  directives: { Ripple, },

  setup(props, {root}) {

    if (!store.hasModule('plans'))
      store.registerModule('plans', PlanStore)

    onUnmounted(() => {
      if (store.hasModule('plans'))
        store.unregisterModule('plans')
    })

    const { loading, submit, form, errors } = useLandfill()

    const onSubmit = () => {

      submit().then(() => {

        root.$bvToast.toast(root.$t('Landfill plan added successfully'), {
          title: root.$t("success"),
          variant: 'success',
          solid: false,
        })
      }).catch(reason => {

        root.$bvToast.toast(root.$t(reason), {
          title: root.$t("Error"),
          variant: 'danger',
          solid: false,
        })
      })
    }


    return {
      onSubmit,
      loading,
      form,
      errors,
    }

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.per-page-selector {
  width: 90px;
}
.actionIcon > button {
  padding: 0;
}
</style>
